import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

const SDPricingSection = ({ content, onOpenModal }) => (
  <section className="py-20 bg-white" id="pricing" data-testid="sd-pricing-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {content.pricing === 'quote' ? (
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter mb-4">Get a Custom Quote</h2>
          <p className="font-body text-base text-[#4A5D53] mb-8 leading-relaxed">Every project is unique. Contact us for a personalized quote tailored to your specific needs and requirements.</p>
          <Button 
            onClick={() => onOpenModal && onOpenModal(`Get a Quote - ${content.title}`)} 
            className="bg-[#C85A40] hover:bg-[#A64730] text-white"
            data-testid="get-quote-btn"
          >
            Get a Quote
          </Button>
        </div>
      ) : (
        <>
          <div className="text-center mb-12">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter mb-4">{content.title} Pricing</h2>
            <p className="font-body text-base text-[#4A5D53] leading-relaxed">Transparent pricing with no hidden fees. Choose the package that fits your needs.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {(content.pricing && content.pricing.length > 0 ? content.pricing : []).map((plan, index) => (
              <Card key={index} className={`p-6 flex flex-col ${plan.popular ? 'border-4 border-[#C85A40] shadow-2xl' : 'border-2'}`} data-testid={`sd-pricing-card-${index}`}>
                {plan.popular && (
                  <div className="bg-[#C85A40] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">MOST POPULAR</div>
                )}
                <h3 className="text-xl font-bold text-[#1A3628] mb-2">{plan.name}</h3>
                <div className="mb-2">
                  <span className="text-4xl font-bold text-[#C85A40]">{typeof plan.price === 'number' ? `$${plan.price}` : plan.price}</span>
                  {plan.description && <p className="text-gray-600 text-sm mt-1">{plan.description}</p>}
                </div>
                <div className="flex-1 overflow-y-auto max-h-64 mb-6 pr-2 scrollbar-thin scrollbar-thumb-[#C85A40] scrollbar-track-gray-100">
                  <ul className="space-y-3">
                    {plan.features.map((feature, i) => (
                      <li key={i} className="flex items-start space-x-2">
                        <Check className="h-5 w-5 text-[#C85A40] flex-shrink-0 mt-0.5" />
                        <span className="text-base text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <Button onClick={() => onOpenModal && onOpenModal(`Get Started - ${plan.name} - ${content.title}`)} className="w-full bg-[#C85A40] hover:bg-[#A64730] text-white mt-auto">
                  Register Your Trademark
                </Button>
              </Card>
            ))}
          </div>
        </>
      )}
    </div>
  </section>
);

export default SDPricingSection;
